module.exports = __webpack_public_path__ + "static/img/13.68a391d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/13.png
// module id = 1R48
// module chunks = 0